/* eslint-disable react/no-danger */
import React from 'react'
import classes from '@src/styles/disposal/caseStudy.module.css'

export type CaseStudyProps = {
  heading: string
  contentList: string[]
  imageSrc: string
}

function CaseStudy({ heading, contentList, imageSrc }: CaseStudyProps) {
  return (
    <section>
      <div className={classes.container}>
        <h2 className={classes.title}>
          <span>Case Studies</span>
        </h2>
        <div className={classes.caseStudy}>
          <div className={classes.caseContent}>
            <div className={classes.textContainer}>
              <div className={classes.subText}>{heading}</div>
              <div className={classes.contentContainer}>
                <div className={classes.descriptionContainer}>
                  {contentList.map((content: string) => (
                    <p
                      key={content}
                      className={classes.description}
                      dangerouslySetInnerHTML={{ __html: content }}
                    />
                  ))}
                </div>
                <img
                  className={classes.caseStudyImg}
                  width='570'
                  height='669'
                  src={imageSrc}
                  alt={heading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CaseStudy
